import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import {
    Box,
    Typography,
    TextField,
    Button,
    List,
    ListItem,
    IconButton,
    FormHelperText,
    Paper,
    FormLabel
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';


const ResourcesSection = ({ onNext, formData }) => {
    const { control, handleSubmit, formState: { errors }, setValue, watch } = useForm({
        defaultValues: {
            zasoby_wstep_pytanie: '',
            zasoby_lista: [],
            zasoby_brakujace: ''
        }
    });

    const [currentStep, setCurrentStep] = useState(0);
    const [newResource, setNewResource] = useState('');
    const [firstStep, setFirstStep] = useState('');
    const [thirdStep, setThirdStep] = useState('');
    const resources = watch('zasoby_lista');

    const handleAddResource = () => {
        if (newResource.trim() && resources.length < 8) {
            setValue('zasoby_lista', [...resources, newResource.trim()]);
            setNewResource('');
        }
    };

    const handleRemoveResource = (index) => {
        setValue('zasoby_lista', resources.filter((_, i) => i !== index));
    };

    const handleNext = () => {
        if (currentStep < 2) {
            setCurrentStep(currentStep + 1);
        } else {
            handleSubmit(onNext)();
        }
    };
    const thoughts = (goal) => {
        switch (goal) {
            case "Szukam pierwszej pracy":
                return `Co takiego wiesz o sobie co sprawia, że znalezienie pierwszej pracy jest możliwe?`;
            case "Szukam pracy":
                return `Co takiego wiesz o sobie co sprawia, że znalezienie pracy jest możliwe?`;
            case "Myślę o znalezieniu innej/nowej pracy":
                return `Co takiego wiesz o sobie co sprawia, że decyzja o szukaniu innej pracy jest możliwa?`;
            case "Wracam na rynek pracy":
                return `Co takiego wiesz o sobie co sprawia, że powrót na rynek pracy jest możliwy?`;
            case "Przekwalifikowuje się":
                return `Co takiego wiesz o sobie co sprawia, że przekwalifikowanie się jest możliwe?`;
            default:
                return "";
        }
    }
    const whatMore = (goal) => {
        switch (goal) {
            case "Szukam pierwszej pracy":
                return "Czego jeszcze potrzebujesz by znalezienie pierwszej pracy było możliwe?";
            case "Szukam pracy":
                return "Czego jeszcze potrzebujesz by znalezienie pracy było możliwe?";
            case "Myślę o znalezieniu innej/nowej pracy":
                return "Czego jeszcze potrzebujesz by decyzja o szukaniu innej pracy była możliwa?";
            case "Wracam na rynek pracy":
                return "Czego jeszcze potrzebujesz by powrót na rynek pracy był możliwy?";
            case "Przekwalifikowuje się":
                return "Czego jeszcze potrzebujesz by przekwalifikowanie się było możliwe?";
            default:
                return "";
        }
    }

    return (
        <Box component="form" sx={{ mt: 3 }}>
            {currentStep === 0 && (
                <>
                    <FormLabel>
                        <Typography variant="h6" color="black" gutterBottom>
                            {thoughts(formData.cel_wybor)}
                        </Typography>
                    </FormLabel>
                    <Controller
                        name="zasoby_wstep_pytanie"
                        control={control}
                        rules={{ required: "To pole jest wymagane" }}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                fullWidth
                                onChange={(e) => {
                                    setFirstStep(e.target.value); field.onChange(e.target.value)
                                    setValue('zasoby_wstep_pytanie', e.target.value)
                                }}
                                multiline
                                rows={3}
                                error={!!errors.zasoby_wstep_pytanie}
                                helperText={errors.zasoby_wstep_pytanie?.message}
                                sx={{ mb: 3 }}
                            />
                        )}
                    />
                </>
            )}

            {currentStep === 1 && (
                <>
                    <Typography variant="h6" color="black" gutterBottom>
                        Wymień 8 Twoich cech, umiejętności, lub kwalifikacji które Ci w tym mogą pomóc:
                    </Typography>
                    <Box sx={{ mb: 3 }}>
                        <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                            <TextField
                                fullWidth
                                value={newResource}
                                onChange={(e) => setNewResource(e.target.value)}
                                placeholder="Wpisz zasób..."
                                disabled={resources.length >= 8}
                            />
                            <Button
                                onClick={handleAddResource}
                                disabled={!newResource.trim() || resources.length >= 8}
                                color="primary"
                            >
                                Dodaj odpowiedź
                            </Button>
                        </Box>
                        <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
                            <List>
                                {resources.map((resource, index) => (
                                    <ListItem
                                        key={index}
                                        secondaryAction={
                                            <IconButton
                                                edge="end"
                                                aria-label="delete"
                                                onClick={() => handleRemoveResource(index)}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        }
                                    >
                                        {`${index + 1}. ${resource}`}
                                    </ListItem>
                                ))}
                            </List>
                        </Paper>
                        {errors.zasoby_lista && (
                            <FormHelperText error>{errors.zasoby_lista.message}</FormHelperText>
                        )}
                    </Box>
                </>
            )}

            {currentStep === 2 && (
                <>
                    <FormLabel>
                        <Typography variant="h6" color="black" gutterBottom>
                            {whatMore(formData.cel_wybor)}
                        </Typography>
                    </FormLabel>
                    <Controller
                        name="zasoby_brakujace"
                        control={control}
                        rules={{ required: "To pole jest wymagane" }}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                fullWidth
                                multiline
                                onChange={(e) => {
                                    setThirdStep(e.target.value); field.onChange(e.target.value)
                                    setValue('zasoby_brakujace', e.target.value)
                                }}
                                rows={3}
                                error={!!errors.zasoby_brakujace}
                                helperText={errors.zasoby_brakujace?.message}
                                sx={{ mb: 3 }}
                            />
                        )}
                    />
                </>
            )}

            <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleNext}
                disabled={currentStep === 1 && resources.length < 4 || currentStep === 2 && !thirdStep.length || currentStep === 0 && !firstStep.length}
                sx={{ mt: 2 }}
            >
                {'Dalej'}
            </Button>
        </Box>
    );
};

export default ResourcesSection;